__turbopack_context__.v({
  "introsection": "GiNpiq_introsection",
  "videocontainer": "GiNpiq_videocontainer",
});
